module.exports = __webpack_public_path__ + "media/images/home/handshake-b1421792fe4406616817d5d9532eacf7.svg";